export const getCompanyReport = (ggsId) => ({apis}) => {
  let countryCode = ggsId.substr(0, 2)
  let language = countryCode === 'BR' ? 'pt' : 'en'
  let payload = apis.getCompanyReport(ggsId, language).map((x) => x)
  return {
    type: 'GET_COMPANY_REPORT',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/report/actions.js